import styled from "styled-components"

export const Container = styled.div`
  display: block;
  max-width: 100% !important;
  margin-bottom: 50px;
  padding: 40px 50px;
  text-align: center;
`
export const Button = styled.button`
  box-shadow: inset 0 0 0 0 rgb(34 36 38 / 15%);
  background-color: #2185d0;
  background-image: none;
  color: #fff;
  text-shadow: none;
  font-size: 1rem;
`
